import moment from 'moment';
import Holidays from "date-holidays";
import { isNullOrEmpty } from './string-helper';
export class DateTime {
    /**
     *
     */
    constructor(value) {
        if (value instanceof Date) {
            this._value = moment(value);
        }
        else {
            if (isNullOrEmpty(value)) {
                throw Error('ArgumentNullException: value');
            }
            value = value.trim();
            switch (value.length) {
                case 10:
                    this._value = moment(value, 'DD/MM/yyyy');
                    break;
                case 16:
                    this._value = moment(value, 'DD/MM/yyyy hh:mm');
                    break;
                case 19:
                    this._value = moment(value, 'DD/MM/yyyy hh:mm:ss');
                    break;
                default:
                    throw Error('InvalidArgumentException: value');
            }
        }
    }
    static get Now() {
        const date = moment().locale('es').format('DD/MM/yyyy hh:mm:ss');
        return new DateTime(date);
    }
    ToString(format) {
        return this._value.format(format);
    }
    ToJsDate() {
        return this._value.toDate();
    }
    TruncateDate() {
        const tmp = this._value.format('DD/MM/yyyy');
        return moment(tmp, 'DD/MM/yyyy').toDate();
    }
    AddHours(hours) {
        if (isNaN(hours)) {
            console.log("Value provided for \"hours\" was not a number");
        }
        const newDate = this._value.add(hours, 'hours').toDate();
        return new DateTime(newDate);
    }
    AddDays(days) {
        if (isNaN(days)) {
            console.log("Value provided for \"days\" was not a number");
        }
        const newDate = this._value.add(days, 'days').toDate();
        return new DateTime(newDate);
    }
    AddBusinessDays(days) {
        if (isNaN(days)) {
            console.log("Value provided for \"days\" was not a number");
        }
        let newDate;
        const direction = Math.sign(days);
        const hd = new Holidays('CO');
        if (direction > 0) {
            while (days > 0) {
                // Agregar un día
                newDate = this._value.add(1, 'days').toDate();
                if (hd.isHoliday(newDate)) {
                    continue;
                }
                // Si el día es diferente a domingo o sábado se descuenta uno del conteo
                var dow = newDate.getDay();
                if (dow != 0 && dow != 6) {
                    days--;
                }
            }
        }
        else {
            while (days < 0) {
                // Agregar un día
                newDate = this._value.add(-1, 'days').toDate();
                if (hd.isHoliday(newDate)) {
                    continue;
                }
                // Si el día es diferente a domingo o sábado se descuenta uno del conteo
                var dow = newDate.getDay();
                if (dow != 0 && dow != 6) {
                    days--;
                }
            }
        }
        const date = new DateTime(newDate).TruncateDate();
        return new DateTime(date);
    }
    get Date() {
        return new DateTime(this.ToString("DD/MM/yyyy"));
    }
}
